import type { WorldCupForecastState } from '@wc26-forecast/model/types';

export const initialState: WorldCupForecastState = {
  teams: {
    ids: [
      1, 2, 3, 4,
      5, 6, 7, 8,
      9, 10, 11, 12,
      13, 14, 15, 16,
      17, 18, 19, 20,
      21, 22, 23, 24,
      25, 26, 27, 28,
      29, 30, 31, 32,
      33, 34, 35, 36,
      37, 38, 39, 40,
      41, 42, 43, 44,
      45, 46, 47, 48,
    ],
    byId: {
      1: {
        id: 1,
        code: 'MEX',
        flag: 'mexico',
      },
      2: {
        id: 2,
        code: 'RSA',
        flag: 'south-africa',
      },
      3: {
        id: 3,
        code: 'KOR',
        flag: 'south-korea',
      },
      4: {
        id: 4,
        code: 'CZE',
        flag: 'cz',
      },
      5: {
        id: 5,
        code: 'CAN',
        flag: 'ca',
      },
      6: {
        id: 6,
        code: 'BIH',
        flag: 'ba',
      },
      7: {
        id: 7,
        code: 'QAT',
        flag: 'qatar',
      },
      8: {
        id: 8,
        code: 'SUI',
        flag: 'switzerland',
      },
      9: {
        id: 9,
        code: 'BRA',
        flag: 'br',
      },
      10: {
        id: 10,
        code: 'MAR',
        flag: 'morocco',
      },
      11: {
        id: 11,
        code: 'HAI',
        flag: 'haiti',
      },
      12: {
        id: 12,
        code: 'SCO',
        flag: 'scotland',
      },
      13: {
        id: 13,
        code: 'USA',
        flag: 'united-states-of-america',
      },
      14: {
        id: 14,
        code: 'PAR',
        flag: 'paraguay',
      },
      15: {
        id: 15,
        code: 'AUS',
        flag: 'australia',
      },
      16: {
        id: 16,
        code: 'TUR',
        flag: 'turkey',
      },
      17: {
        id: 17,
        code: 'GER',
        flag: 'germany',
      },
      18: {
        id: 18,
        code: 'CUW',
        flag: 'curacao',
      },
      19: {
        id: 19,
        code: 'CIV',
        flag: 'ivory-coast',
      },
      20: {
        id: 20,
        code: 'ECU',
        flag: 'ec',
      },
      21: {
        id: 21,
        code: 'NED',
        flag: 'netherlands',
      },
      22: {
        id: 22,
        code: 'JPN',
        flag: 'japan',
      },
      23: {
        id: 23,
        code: 'SWE',
        flag: 'sweden',
      },
      24: {
        id: 24,
        code: 'TUN',
        flag: 'tunisia',
      },
      25: {
        id: 25,
        code: 'BEL',
        flag: 'be',
      },
      26: {
        id: 26,
        code: 'EGY',
        flag: 'egypt',
      },
      27: {
        id: 27,
        code: 'IRN',
        flag: 'iran',
      },
      28: {
        id: 28,
        code: 'NZL',
        flag: 'new-zealand',
      },
      29: {
        id: 29,
        code: 'ESP',
        flag: 'spain',
      },
      30: {
        id: 30,
        code: 'CPV',
        flag: 'cv',
      },
      31: {
        id: 31,
        code: 'KSA',
        flag: 'saudi-arabia',
      },
      32: {
        id: 32,
        code: 'URU',
        flag: 'uruguay',
      },
      33: {
        id: 33,
        code: 'FRA',
        flag: 'france',
      },
      34: {
        id: 34,
        code: 'SEN',
        flag: 'senegal',
      },
      35: {
        id: 35,
        code: 'IRQ',
        flag: 'iraq',
      },
      36: {
        id: 36,
        code: 'NOR',
        flag: 'norway',
      },
      37: {
        id: 37,
        code: 'ARG',
        flag: 'ar',
      },
      38: {
        id: 38,
        code: 'ALG',
        flag: 'dz',
      },
      39: {
        id: 39,
        code: 'AUT',
        flag: 'austria',
      },
      40: {
        id: 40,
        code: 'JOR',
        flag: 'jordan',
      },
      41: {
        id: 41,
        code: 'POR',
        flag: 'portugal',
      },
      42: {
        id: 42,
        code: 'COD',
        flag: 'democratic-republic-of-congo',
      },
      43: {
        id: 43,
        code: 'UZB',
        flag: 'uz',
      },
      44: {
        id: 44,
        code: 'COL',
        flag: 'co',
      },
      45: {
        id: 45,
        code: 'ENG',
        flag: 'england',
      },
      46: {
        id: 46,
        code: 'CRO',
        flag: 'hr',
      },
      47: {
        id: 47,
        code: 'GHA',
        flag: 'ghana',
      },
      48: {
        id: 48,
        code: 'PAN',
        flag: 'panama',
      },
    },
  },
  groups: {
    ids: [
      'A', 'B', 'C', 'D', 'E', 'F',
      'G', 'H', 'I', 'J', 'K', 'L',
    ],
    byId: {
      A: {
        id: 'A',
        teamIds: [ 1, 2, 3, 4 ],
      },
      B: {
        id: 'B',
        teamIds: [ 5, 6, 7, 8 ],
      },
      C: {
        id: 'C',
        teamIds: [ 9, 10, 11, 12 ],
      },
      D: {
        id: 'D',
        teamIds: [ 13, 14, 15, 16 ],
      },
      E: {
        id: 'E',
        teamIds: [ 17, 18, 19, 20 ],
      },
      F: {
        id: 'F',
        teamIds: [ 21, 22, 23, 24 ],
      },
      G: {
        id: 'G',
        teamIds: [ 25, 26, 27, 28 ],
      },
      H: {
        id: 'H',
        teamIds: [ 29, 30, 31, 32 ],
      },
      I: {
        id: 'I',
        teamIds: [ 33, 34, 35, 36 ],
      },
      J: {
        id: 'J',
        teamIds: [ 37, 38, 39, 40 ],
      },
      K: {
        id: 'K',
        teamIds: [ 41, 42, 43, 44 ],
      },
      L: {
        id: 'L',
        teamIds: [ 45, 46, 47, 48 ],
      },
    },
  },
  matches: {
    ids: [
      73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88,
      89, 90, 91, 92, 93, 94, 95, 96,
      97, 98, 99, 100,
      101, 102,
      103,
      104,
    ],
    byId: {
      73: {
        id: 73,
        city: 'Inglewood',
        date: 1782673200,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'A',
          place: 2,
        },
        awaySource: {
          type: 'GROUP_PLACE',
          group: 'B',
          place: 2,
        },
      },
      74: {
        id: 74,
        city: 'Foxborough',
        date: 1782765000,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'E',
          place: 1,
        },
        awaySource: {
          type: 'BEST_THIRD',
          slot: 'BEST_THIRD_1',
        },
      },
      75: {
        id: 75,
        city: 'Guadalupe',
        date: 1782781200,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'F',
          place: 1,
        },
        awaySource: {
          type: 'GROUP_PLACE',
          group: 'C',
          place: 2,
        },
      },
      76: {
        id: 76,
        city: 'Houston',
        date: 1782752400,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'C',
          place: 1,
        },
        awaySource: {
          type: 'GROUP_PLACE',
          group: 'F',
          place: 2,
        },
      },
      77: {
        id: 77,
        city: 'East Rutherford',
        date: 1782853200,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'I',
          place: 1,
        },
        awaySource: {
          type: 'BEST_THIRD',
          slot: 'BEST_THIRD_2',
        },
      },
      78: {
        id: 78,
        city: 'Arlington',
        date: 1782838800,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'E',
          place: 2,
        },
        awaySource: {
          type: 'GROUP_PLACE',
          group: 'I',
          place: 2,
        },
      },
      79: {
        id: 79,
        city: 'Mexico City',
        date: 1782867600,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'A',
          place: 1,
        },
        awaySource: {
          type: 'BEST_THIRD',
          slot: 'BEST_THIRD_5',
        },
      },
      80: {
        id: 80,
        city: 'Atlanta',
        date: 1782921600,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'L',
          place: 1,
        },
        awaySource: {
          type: 'BEST_THIRD',
          slot: 'BEST_THIRD_6',
        },
      },
      81: {
        id: 81,
        city: 'Santa Clara',
        date: 1782950400,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'D',
          place: 1,
        },
        awaySource: {
          type: 'BEST_THIRD',
          slot: 'BEST_THIRD_3',
        },
      },
      82: {
        id: 82,
        city: 'Seattle',
        date: 1782936000,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'G',
          place: 1,
        },
        awaySource: {
          type: 'BEST_THIRD',
          slot: 'BEST_THIRD_4',
        },
      },
      83: {
        id: 83,
        city: 'Toronto',
        date: 1783033200,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'K',
          place: 2,
        },
        awaySource: {
          type: 'GROUP_PLACE',
          group: 'L',
          place: 2,
        },
      },
      84: {
        id: 84,
        city: 'Inglewood',
        date: 1783018800,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'H',
          place: 1,
        },
        awaySource: {
          type: 'GROUP_PLACE',
          group: 'J',
          place: 2,
        },
      },
      85: {
        id: 85,
        city: 'Vancouver',
        date: 1783047600,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'B',
          place: 1,
        },
        awaySource: {
          type: 'BEST_THIRD',
          slot: 'BEST_THIRD_7',
        },
      },
      86: {
        id: 86,
        city: 'Miami Gardens',
        date: 1783116000,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'J',
          place: 1,
        },
        awaySource: {
          type: 'GROUP_PLACE',
          group: 'H',
          place: 2,
        },
      },
      87: {
        id: 87,
        city: 'Kansas City',
        date: 1783128600,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'K',
          place: 1,
        },
        awaySource: {
          type: 'BEST_THIRD',
          slot: 'BEST_THIRD_8',
        },
      },
      88: {
        id: 88,
        city: 'Arlington',
        date: 1783101600,
        round: 'ROUND_OF_32',
        homeSource: {
          type: 'GROUP_PLACE',
          group: 'D',
          place: 2,
        },
        awaySource: {
          type: 'GROUP_PLACE',
          group: 'G',
          place: 2,
        },
      },
      89: {
        id: 89,
        city: 'Arlington',
        date: 1783198800,
        round: 'ROUND_OF_16',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 74,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 77,
        },
      },
      90: {
        id: 90,
        city: 'Arlington',
        date: 1783184400,
        round: 'ROUND_OF_16',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 73,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 75,
        },
      },
      91: {
        id: 91,
        city: 'Arlington',
        date: 1783281600,
        round: 'ROUND_OF_16',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 76,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 78,
        },
      },
      92: {
        id: 92,
        city: 'Arlington',
        date: 1783296000,
        round: 'ROUND_OF_16',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 79,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 80,
        },
      },
      93: {
        id: 93,
        city: 'Arlington',
        date: 1783364400,
        round: 'ROUND_OF_16',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 83,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 84,
        },
      },
      94: {
        id: 94,
        city: 'Arlington',
        date: 1783382400,
        round: 'ROUND_OF_16',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 81,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 82,
        },
      },
      95: {
        id: 95,
        city: 'Arlington',
        date: 1783440000,
        round: 'ROUND_OF_16',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 86,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 88,
        },
      },
      96: {
        id: 96,
        city: 'Arlington',
        date: 1783454400,
        round: 'ROUND_OF_16',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 85,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 87,
        },
      },
      97: {
        id: 97,
        city: 'Arlington',
        date: 1783627200,
        round: 'QUARTER_FINAL',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 89,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 90,
        },
      },
      98: {
        id: 98,
        city: 'Arlington',
        date: 1783710000,
        round: 'QUARTER_FINAL',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 93,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 94,
        },
      },
      99: {
        id: 99,
        city: 'Arlington',
        date: 1783803600,
        round: 'QUARTER_FINAL',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 91,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 92,
        },
      },
      100: {
        id: 100,
        city: 'Arlington',
        date: 1783818000,
        round: 'QUARTER_FINAL',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 95,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 96,
        },
      },
      101: {
        id: 101,
        city: 'Arlington',
        date: 1784055600,
        round: 'SEMI_FINAL',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 97,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 98,
        },
      },
      102: {
        id: 102,
        city: 'Arlington',
        date: 1784142000,
        round: 'SEMI_FINAL',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 99,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 100,
        },
      },
      103: {
        id: 103,
        city: 'Arlington',
        date: 1784408400,
        round: 'THIRD_PLACE',
        homeSource: {
          type: 'MATCH_LOSER',
          matchId: 101,
        },
        awaySource: {
          type: 'MATCH_LOSER',
          matchId: 102,
        },
      },
      104: {
        id: 104,
        city: 'Arlington',
        date: 1784487600,
        round: 'FINAL',
        homeSource: {
          type: 'MATCH_WINNER',
          matchId: 101,
        },
        awaySource: {
          type: 'MATCH_WINNER',
          matchId: 102,
        },
      },
    },
  },
  bestThirdRules: {
    BEST_THIRD_1: [ 'A', 'B', 'C', 'D', 'F' ],
    BEST_THIRD_2: [ 'C', 'D', 'F', 'G', 'H' ],
    BEST_THIRD_3: [ 'B', 'E', 'F', 'I', 'J' ],
    BEST_THIRD_4: [ 'A', 'E', 'H', 'I', 'J' ],
    BEST_THIRD_5: [ 'C', 'E', 'F', 'H', 'I' ],
    BEST_THIRD_6: [ 'E', 'H', 'I', 'J', 'K' ],
    BEST_THIRD_7: [ 'E', 'F', 'G', 'I', 'J' ],
    BEST_THIRD_8: [ 'D', 'E', 'I', 'J', 'L' ],
  },
  matchesByRound: {
    ROUND_OF_32: {
      left: [ 74, 77, 73, 75, 83, 84, 81, 82 ],
      right: [ 76, 78, 79, 80, 86, 88, 85, 87 ],
    },
    ROUND_OF_16: {
      left: [ 89, 90, 93, 94 ],
      right: [ 91, 92, 95, 96 ],
    },
    QUARTER_FINAL: {
      left: [ 97, 98 ],
      right: [ 99, 100 ],
    },
    SEMI_FINAL: {
      left: [ 101 ],
      right: [ 102 ],
    },
    THIRD_PLACE: {
      left: [ 103 ],
      right: [],
    },
    FINAL: {
      left: [ 104 ],
      right: [],
    },
  },
  prediction: {
    groupPlacements: {},
    bestThirdTeams: {
      BEST_THIRD_1: null,
      BEST_THIRD_2: null,
      BEST_THIRD_3: null,
      BEST_THIRD_4: null,
      BEST_THIRD_5: null,
      BEST_THIRD_6: null,
      BEST_THIRD_7: null,
      BEST_THIRD_8: null,
    },
    matchResults: {},
    finalScorePrediction: {
      homeScore: null,
      awayScore: null,
    },
    hasUserPrediction: false,
  },
};
